module.exports = __webpack_public_path__ + "images/cebsblogo_white.1785317263746.png";